import React, { useState, useEffect } from 'react';
import Header from '../Header/AppHeader';
import baseURL from '../Common/Config';
import Axiosfetch from '../Common/Axiosfetch';
import moment from 'moment';
import FailureAlert from '../Common/Failure';
import Select from 'react-select';

const InvoiceSnapshot = () => {

    const [Invoices, setInvoices] = useState([]);
    const [InvoicesSnapShot, setInvoicesSnapShot] = useState({});

    const getInvoicesSuccess = (data) => {
        if (data.length > 0) {
            var invoices = [];
            data.forEach(invoice => {
                let invoiceNumber = "Invoice/" + (invoice.Quotation.Customer.Name.split(' ')[0].trim()) + "/#" +
                    invoice.ID + "/" + moment(invoice.CreatedDate).local().format("DDMMYYYY");
                invoices.push({ value: invoice.ID, label: invoiceNumber });
            });

            setInvoices(invoices);
        }
        else {
            setInvoices([]);
        }
    };

    const FetchInvoiceDetailsByID = (InvoiceData) => {
        let invoiceID = parseInt(InvoiceData ? InvoiceData.value : 0);
        if (invoiceID > 0) {
            Axiosfetch(baseURL + "InvoiceSnapShotByID", "POST", { InvoiceID: invoiceID }, GetInvoiceSnapShot, Failure);
        }
        else {
            setInvoicesSnapShot({});
        }
    };

    const GetInvoiceSnapShot = (data) => {
        if (data.length > 0) {
            setInvoicesSnapShot(data[0]);
        }
        else {
            setInvoicesSnapShot({});
        }
    };

    const Failure = (err) => {
        FailureAlert(err);
    };

    const FetchAllInvoices = () => {
        Axiosfetch(baseURL + "GetAllInvoicesByStatus", "POST", { Status: 2 }, getInvoicesSuccess, Failure);
    };

    useEffect(() => {
        FetchAllInvoices();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return (
        <div>
            <Header></Header>
            <div className="container-fluid InvoiceTheme sidemenu-show">
                <div className="row">
                <div className="col-md-3 col-sm-3 align-right">
                        <h5>Invoice<span className="mandatoryStar">*</span></h5>
                    </div>
                    <div className="col-md-6 col-sm-6">
                        <div style={{ width: "90%" }}>
                            <Select isClearable={true} isSearchable={true} placeholder="Select Invoice"
                                options={Invoices}
                                onChange={FetchInvoiceDetailsByID}></Select>
                        </div>
                    </div>
                </div>
            </div>
            <div className="row" style={{ marginTop: "10px", width: "93%", marginLeft: "5rem", marginBottom: "10px" }}>
                <div className="col-md-12 col-sm-12">
                    {
                        InvoicesSnapShot.ImageData !== undefined && <img width="100%" src={InvoicesSnapShot.ImageData} alt="QuotationImage"></img>
                    }

                    {
                        InvoicesSnapShot.ImageData === undefined && (<div style={{ position: "relative", top: "30vh", padding: "10px", backgroundColor: "#ccc" }} className="offset-md-1 col-md-10 col-sm-10 align-center">No Invoice History Available. Only Generated Invoices will be available.</div>)
                    }
                </div>
            </div>
        </div>
    );
};

export default InvoiceSnapshot;